import { Box, tooltipClasses, TooltipProps, Tooltip as MTooltip } from '@mui/material';
import { styled, SxProps } from '@mui/material/styles';
import { memo } from 'react';

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#000',
    color: 'white',
    minWidth: '8rem',
    fontSize: '1rem',
    lineHeight: theme.typography.pxToRem(18),
    padding: '1rem',
    textAlign: 'center',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#000',
  },
}));

interface TruncatedTooltipProps {
  label: string;
  message: string;
  sx?: SxProps;
}

function TooltipMessage({ label, message, sx }: TruncatedTooltipProps) {
  return (
    <Box sx={{ display: 'flex' }}>
      <Tooltip sx={sx} arrow title={`${message}`} placement="top" disableHoverListener={!label}>
        <span>{label}</span>
      </Tooltip>
    </Box>
  );
}

export default memo(TooltipMessage);
